import { memo } from 'react'
import { Zap } from 'lucide-react'
import { AttachmentStub } from '../attachment-stub'
import { useRemoveAttachment } from '../hooks/use-remove-attachment'
import type { AttachmentPillProps } from '../types'

export const SkillAttachment = memo((attachment: AttachmentPillProps) => {
  const onRemove = useRemoveAttachment(attachment)

  const name =
    (attachment.pending?.type === 'skill' ? attachment.pending.name : undefined) ??
    (attachment.attachment as { name?: string } | undefined)?.name ??
    'Action'

  return <AttachmentStub label={name} icon={<Zap size={16} />} onRemove={onRemove} />
})
SkillAttachment.displayName = 'SkillAttachment'
